(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["up-levels-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('up-an-hero')) {
  customElements.define('up-an-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-up-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-up-hero-dot]')];
      this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
      this.querySelector('[data-up-hero-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-up-hero-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-up-hero-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.show(index);
      }, options);
      this.show(this.index);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.hidden = !active;
        if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
        if (this.dots[position]) {
          if (active) this.dots[position].setAttribute('aria-current', 'true');
          else this.dots[position].removeAttribute('aria-current');
        }
      });
    }
  });
}
if (!customElements.get('up-an-carousel')) {
  customElements.define('up-an-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-up-track]');
      if (!this.track) return;
      this.previous = this.querySelector('[data-up-previous]');
      this.next = this.querySelector('[data-up-next]');
      this.progress = this.querySelector('[data-up-progress]');
      this.querySelector('[data-up-controls]')?.removeAttribute('hidden');
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
      this.resizeObserver.observe(this.track);
      this.scheduleUpdate();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.isConnected || !this.track) return;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const offset = Math.min(maximum, Math.max(0, this.track.scrollLeft));
      if (this.previous) this.previous.disabled = offset <= 2;
      if (this.next) this.next.disabled = offset >= maximum - 2;
      if (this.progress) {
        const width = this.track.scrollWidth ? Math.min(100, this.track.clientWidth / this.track.scrollWidth * 100) : 100;
        this.progress.style.width = `${width}%`;
        this.progress.style.left = `${maximum ? offset / maximum * (100 - width) : 0}%`;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-product-discover"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('up-discover-carousel')) {
  customElements.define('up-discover-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('.up-discover-track');
      this.previous = this.querySelector('[data-discover-previous]');
      this.next = this.querySelector('[data-discover-next]');
      this.progress = this.querySelector('.up-discover-progress span');
      this.controls = this.querySelector('.up-discover-controls');
      if (!this.track || !this.previous || !this.next || !this.progress || !this.controls) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { passive: true, signal: this.abort.signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion() });
        } else {
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    motion() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const card = this.track.querySelector('.up-discover-card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: this.motion() });
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.min(maximum, Math.max(0, this.track.scrollLeft));
      const visible = Math.min(100, this.track.clientWidth / Math.max(1, this.track.scrollWidth) * 100);
      this.controls.hidden = maximum < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= maximum - 2;
      this.progress.style.width = `${visible}%`;
      this.progress.style.left = `${maximum ? position / maximum * (100 - visible) : 0}%`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('up-product-community')){customElements.define('up-product-community',class extends HTMLElement{connectedCallback(){this.events?.abort();this.events=new AbortController();const options={signal:this.events.signal};this.track=this.querySelector('.up-community-slides');this.buttons=[...this.querySelectorAll('[data-slide]')];this.buttons.forEach(button=>button.addEventListener('click',()=>this.track.scrollTo({left:Number(button.dataset.slide)*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}),options));this.track.addEventListener('scroll',()=>{const active=Math.round(this.track.scrollLeft/this.track.clientWidth);this.buttons.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===active)));},options);}disconnectedCallback(){this.events?.abort();}});}

  } catch(e) { console.error(e); }
})();
})();
